import { createAuthClient } from "better-auth/react";
import { ssoClient } from "@better-auth/sso/client";

export const betterAuthClient = createAuthClient({
  basePath: "/api/auth/better-auth",
  plugins: [ssoClient()],
});
